<template>
  <div
    class="video-thumbnail cursor-pointer"
    tabindex="0"
    role="button"
    :title="`Video, ${title}`"
    @click="openModal($event);"
    @keydown.enter="openModal($event);"
    @hide="closeModal"
    :id="uuid"
  >
    <div class="video">
      <div class="video__container">
        <div class="video__overlay">
          <div
            class="thumbnail u-bg-cover u-bg-center"
            :style="{ 'background-image': 'url(' + thumb + ')' }"
          ></div>
        </div>
        <div
          v-if="showTitle"
          class="video__title u-flex u-flex--row u-flex--align-items-center"
        >
          <span class="play-btn-sm"></span>
          <h3 class="h-sm">{{ title }}</h3>
        </div>
      </div>
    </div>
    <a11y-dialog
      :id="`${uuid}_video-modal`"
      dialog-root="#vue-dialog-root"
      :app-root="`#${uuid}`"
      @dialog-ref="(dialog) => assignDialogRef(uuid, dialog)"
      :disable-native="true"
      :class-names= "{ container: 'dialog', overlay: 'fe-modal-overlay' }"
    >
      
      <div class="dialog-content fe-modal">
        <slot name="closeButtonContent">
          <button
            type="button"
            data-a11y-dialog-hide
            @click="closeModal"
            @keydown.enter="closeModal"
            aria-label="Close this dialog window"
            class="fe-modal-close"
          >
            &times;
          </button>
        </slot>
        <div v-if="modalShow">
          <video-modal
            v-if="videoSrc"
            :src="videoSrc"
            :showTitle="showTitle"
            :title="title"
          ></video-modal>
          <you-tube-modal
            v-if="youTubeId"
            :id="youTubeId"
            :showTitle="showTitle"
            :title="title"
            :start="start"
            :lang="lang"
          ></you-tube-modal>
        </div>
      </div>
    </a11y-dialog>
  </div>
</template>
<script>
import VideoModal from "./VideoModal.vue";
import YouTubeModal from "./YouTubeModal.vue";

export default {
  name: 'VideoThubnail',
  components: { VideoModal, YouTubeModal },
  props: {
    showTitle: {
      default: false,
      type: Boolean,
    },
    youTubeId: null,
    videoSrc: null,

    thumb: null,
    title: null,
    start: "",
    lang: ""
  },
  useFallback() {
    return true;
  },
  data() {
    return {
      modalShow: false,
      currentComponent: null,
      uuid: "",
      dialog: {},
      name: "",
    };
  },
  mounted() {
    this.uuid =
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .substr(2);
  },
  methods: {
    closeModal() {
      this.modalShow = false;
      this.dialog.hide();
    },

    openDialog(event) {
      if (event && !event.code) {
        event.preventDefault();
      }
      if (event.code === "Enter") {
        event.preventDefault();
        this.dialog.show();
      }

      if (!event.code && this.dialog) {
        this.dialog.show();
      }
      console.log(this.dialog);
    },
    assignDialogRef(name, dialog) {
      if (name && dialog) {
        this.dialog = dialog;
        this.name = name;
        this.dialog.on('hide', this.closeModal);
        this.dialog.on('destroy', ()=>this.dialog.off('hide', this.closeModal));
      }
    },
    openModal(event) {
      this.modalShow = true;
      this.$nextTick(() => {
        this.openDialog(event);
      });
    },
  },
};
</script>
